import { forwardRef, useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as Cloud } from 'assets/icon/ic_cloudy_c.svg';
import { ReactComponent as Rain } from 'assets/icon/ic_rainy_c.svg';
import { ReactComponent as Sun } from 'assets/icon/ic_sunny_c.svg';
import { ReactComponent as Thunder } from 'assets/icon/ic_thunder_c.svg';

export const CONTENT_TYPE = {
    THUNDER: '1',   // 雷
    RAIN: '2',      // 雨
    CLOUD: '3',     // 曇り
    SUN: '4',       // 晴れ
};

/**
 * 天気マークアイコンをレンダリングする
 * 
 * @param {*} props 
 * @returns 
 */
const WeatherIcon = (props) => {
    switch (props.content) {
        case CONTENT_TYPE.CLOUD:
            return <Cloud {...props} />;
        case CONTENT_TYPE.RAIN:
            return <Rain {...props} />;
        case CONTENT_TYPE.SUN:
            return <Sun {...props} />;
        case CONTENT_TYPE.THUNDER:
            return <Thunder {...props} />;
        default:
            return <></>;
    }
};

/**
 * 天気マークアイコンリストをレンダリングする
 */
const WeatherCandidate = forwardRef(({ name, watch }, ref) => {
    const checkedIconValue = watch(name);
    const [hoverIconValue, setHoverIconValue] = useState('0');

    // アイコン操作（ホバー、チェック済み）に応じたCSSレンダリングの処理
    const iconClassNames = (checkNum, checkedIconValue, hoverIconValue) => {
        const checkedIconClass = 'w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rubberBand';
        const hoverIconClass = 'w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14';
        const normalIconClass = 'w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12';
        const baseClass = 'first:fill-current hover:cursor-pointer';

        return classNames(
            `${
                checkedIconValue === checkNum
                    ? checkedIconClass
                    : hoverIconValue === checkNum
                    ? hoverIconClass
                    : normalIconClass
            }`,
            baseClass
        );
    };

    const iconStyle = (checkNum, checkedIconValue) => {
        return {
            fillOpacity: !checkedIconValue ? 1 : checkedIconValue !== checkNum ? 0.5 : 1,
        };
    };

    return (
        <div className='grid grid-cols-5 gap-4 h-16 items-center'>
            {Object.values(CONTENT_TYPE).map((value) => {
                return (
                    <label className='mx-auto' key={value}>
                        <input name={name} hidden type='radio' value={Number(value)} ref={ref} />
                        <div onMouseEnter={() => setHoverIconValue(value)} onMouseLeave={() => setHoverIconValue('0')}>
                            <WeatherIcon
                                content={value}
                                style={iconStyle(value, checkedIconValue)}
                                className={iconClassNames(value, checkedIconValue, hoverIconValue)}
                            />
                        </div>
                    </label>
                );
            })}
        </div>
    );
});

WeatherCandidate.displayName = 'WeatherCandidate';

export default WeatherCandidate;
